/**
 * Defines a tooltip view.
 *
 */
import Backbone from 'backbone';

import jQuery from 'jquery';

var ErrorToolTipView = Backbone.View.extend({
    events: {
        'click body': 'onBodyClicked'
    },

    /**
     *
     * @param args
     *          content: The content to display within the tooltip. Can be html
     *          placement: Optional. Can specify 'bottom' to have the placement to the bottom of the trigger
     */
    initialize: function(args) {
        this.content = args.content; // The content to display.
        this.placement = args.placement; // Allows the orientation of the tooltip to be optionally specified

        this.hideOnBodyClick = args.hideOnBodyClick ? true : false; // The tooltip hides when clicking on page

        this.container = args.container || '.main-body';
    },

    show: function() {
        if (!this.rendered) {
            this.render();
        }

        // Temp solution for HR validation
        var hideClass = '';
        if (this.hideOnBodyClick) hideClass = 'hide-on-body-click';

        this.$el.addClass('error');
        this.$el.addClass('error-tooltip-active');
        this.$el.data('title', this.content);

        this.$el
            .tooltip({
                placement: this.placement,
                template:
                    '<div class="tooltip tooltip-error ' +
                    hideClass +
                    '"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
                trigger: 'manual',
                container: this.container
            })
            .tooltip('show');

        // This is a hack to fix an issue with bootstrap events propagating from the tooltip to the modal
        this.$el.on('hidden.bs.modal', function(e) {
            e.stopPropagation();
        });

        this.$el.on('hide.bs.modal', function(e) {
            e.stopPropagation();
        });

        this.$el.on('hide', function(e) {
            e.stopPropagation();
        });
    },

    hide: function() {
        this.$el
            .removeClass('error')
            .removeClass('error-tooltip-active')
            .tooltip('destroy');
    },

    render: function() {
        this.rendered = true;

        this.onBodyClicked();
        // Nothing to do yet
    },

    onBodyClicked: function() {
        if (this.hideOnBodyClick) {
            var _this = this;
            jQuery('body').one('click', function() {
                jQuery('.hide-on-body-click').fadeOut(100);
                _this.hide();
            });
        }
    }
});

ErrorToolTipView.hideAll = function() {
    jQuery('.error-tooltip-active')
        .tooltip('hide')
        .removeClass('tooltip-active');
};

export default ErrorToolTipView;
